import React, {Component, useEffect, useState} from 'react';
import {getAnnounce} from "./service";
import {Carousel, Divider, Typography} from "antd";
import moment from "moment";
import globalStyle from "../../styles/globalStyle";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import style from "./headerAnnounce.module.css";
import newsDetailPushTarget from "../../utils/NewsDetailPushTarget";

const HeaderAnnounce = (props) => {
    const { history } = props;
    const [data, setData] = useState([]);

    useEffect(() => {
        (async () => {
            const {data} = await getAnnounce();
            const tmp = [];
            for(let i = 0; data!=null && i < data.length; i = i + 2) {
                tmp.push({
                    left: data[i],
                    right: data[i+1],
                })
            }
            setData(tmp);
        })();
    }, []);

    return(
        <div style={{...globalStyle.flexCenterRow, height: 80}}>
            <div style={{...globalStyle.flexSpaceBetweenRow, width: 1200}}>
                <div style={{...globalStyle.flexCenterRow, width: 152}}>
                    <img src={require('../../images/laba_blue.png')} style={{width: 16, height: 16}}/>
                    <div style={{width: 120, fontSize: 16, fontWeight: 700, color: '#1890ff', marginLeft: 16}}>最新资讯：</div>
                </div>
                <div style={{width: 1048}}>
                    {
                        data.length > 0
                            ?   <Carousel autoplay dots={false}>
                                {data.map((item, index) => {
                                    const {left, right} = item;
                                    return(
                                        <div key={index}>
                                            <div style={{...globalStyle.flexSpaceBetweenRow}}>
                                                <div style={{...globalStyle.flexSpaceBetweenRow, height: 80}}>
                                                    {
                                                        left &&
                                                        <>
                                                            <div style={{...globalStyle.flexCenterRow}} onClick={() => {
                                                                history.push({ pathname: `/${newsDetailPushTarget(left.tab)}/${left.id}`});
                                                            }}>
                                                                <img src={require('../../images/rectangle4_blue.png')} style={{marginRight: 8}}/>
                                                                <Typography.Text className={style.title} ellipsis>{left.title}</Typography.Text>
                                                            </div>
                                                            <div style={{marginLeft: 24, whiteSpace: 'nowrap',color:'#1890ff'}} className={style.date}>{moment(left.change_time * 1000).format('YYYY-MM-DD')}</div>
                                                        </>
                                                    }
                                                </div>
                                                <Divider type="vertical" style={{margin: '0 24px', background: '#ccc', height: 20}}/>
                                                <div style={{...globalStyle.flexSpaceBetweenRow, height: 80}}>
                                                    {
                                                        right &&
                                                        <>
                                                            <div style={{...globalStyle.flexCenterRow}} onClick={() => {
                                                                window.scrollTo(0,300);
                                                                history.push({ pathname: `/${newsDetailPushTarget(right.tab)}/${right.id}`});
                                                            }}>
                                                                <img src={require('../../images/rectangle4_blue.png')} style={{marginRight: 8}}/>
                                                                <Typography.Text className={style.title} ellipsis>{right.title}</Typography.Text>
                                                            </div>
                                                            <div style={{marginLeft: 24, whiteSpace: 'nowrap',color:'#1890ff'}} className={style.date}>{moment(right.change_time * 1000).format('YYYY-MM-DD')}</div>
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </Carousel>
                            :   null
                    }
                </div>
            </div>
        </div>
    );
};

export default connect()(withRouter(HeaderAnnounce));

